import { IShellConfig } from '@mitchell/react.component.ux';
import {productHelpService, RepairCenterHeaderRoute} from '@mitchell/redux.module.apd';
import { ShellConstants } from '../../constants';
import {
	UserNameMenuComponent,
	Signout,
	RepairCenter
} from '../routerComponents';

// Application nagivation configuration will go here and replaced below dummy navigations
export const shellConfig: IShellConfig = {
	basename: 'repair-center',
	logo: ShellConstants.MitchellRepairCenterLogo,
	topNavItems: [
		{
			iconName: 'mi-icon-avatar-user',
			menuItemName: 'user-name',
			urlName: 'user',
			menuItemComponent: UserNameMenuComponent,
			onClick: (event: React.MouseEvent<HTMLElement>) => {
				event.preventDefault();
			},
		},
		{
			iconName: 'mi-icon-jobs',
			menuItemName: 'All Open List',
			urlName: 'jobs',
			component: RepairCenter,
		}
	],
	bottomNavItems: [
		{
			iconName: 'mi-icon-help-filled-circle',
			menuItemName: 'Help',
			urlName: 'help',
			onClick: (event: React.MouseEvent<HTMLElement>) => {
				const productName = 'RepairCenter';
				const topicId = 18262;
				productHelpService(productName, topicId);
				event.preventDefault();
			},
		},
		{
			iconName: 'mi-icon-sign-out-left',
			menuItemName: 'Sign Out',
			urlName: 'signout',
			component: Signout,
		}
	],
	applicationHeaderItem: {
		component: RepairCenterHeaderRoute,
		menuItemName: 'applicationHeader',
	},
};
